import React from 'react';

/**
 * Select - Dark-aware select primitive.
 *
 * Companion to Input/Textarea. Base classes first, caller `className`
 * appended so individual utilities can be overridden. Children (<option>s)
 * and all native props (value, onChange, name, disabled, ref, ...) pass
 * through unchanged.
 *
 * @param {Object} props
 * @param {string} props.className - Additional CSS classes (override base)
 * @param {React.ReactNode} props.children - <option> elements
 */
const BASE =
  'w-full px-3 py-2 rounded-lg border transition-colors ' +
  'bg-white text-gray-900 border-gray-300 ' +
  'dark:bg-slate-800 dark:text-slate-100 dark:border-slate-600 ' +
  'focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ' +
  'disabled:opacity-60 disabled:cursor-not-allowed';

const Select = React.forwardRef(({ className = '', children, ...props }, ref) => (
  <select ref={ref} className={`${BASE} ${className}`.trim()} {...props}>
    {children}
  </select>
));

Select.displayName = 'Select';

export default Select;
